import React from 'react';
import { Navigate, useParams } from 'react-router';
import { CookieUtil, RolesUtil, Suspense, useApi } from '@axiom/ui';

import { WindowUtil } from '../utils/window-util';
import { LoadingCurtain } from '../components/LoadingCurtain/LoadingCurtain';
import { UrlVariableParamUtil } from '../utils/url-variable-param-util';
import { UserApi } from '../api/user-api';

export type AuthRouteProps = {
  name?: string;
  children: React.ReactNode;
  roles?: string[] | null;
};

export const AuthRoute = ({ name, children, roles = null }: AuthRouteProps) => {
  const params = useParams();
  const isUserLoggedIn = CookieUtil.hasUserCookie() || null;
  const [{ data: user } = { data: undefined }] = useApi(
    isUserLoggedIn ? UserApi.readUser() : undefined
  );

  if (CookieUtil.isUserExpired()) {
    WindowUtil.toLogin();
    return <LoadingCurtain name="LOADING_CURTAIN" isFullscreen />;
  }

  if (UrlVariableParamUtil(params).invalid) {
    return <Navigate to="/404" replace />;
  }

  return (
    <div data-test={name}>
      <Suspense
        fallback={<LoadingCurtain name="LOADING_CURTAIN" isFullscreen />}
      >
        {RolesUtil.isAllowed(user, roles) ? (
          children
        ) : (
          <Navigate to="/401" replace />
        )}
      </Suspense>
    </div>
  );
};
